import {useDispatch} from 'react-redux';
import {getPhoneDataList} from './esimBlockSlice';
export default class SliceMiddleware {
  constructor(props, stages) {
    this.dispatch = useDispatch();
    this.props = props;
    this.init = () => {
      if (this.props?.phoneDataList?.length == 0) {
        this.dispatch(getPhoneDataList());
      }
    };
    this.operationStages = stages;
  }

  getViews = () => {
    return this.operationStages;
  };
}
